import { Info } from "@mui/icons-material";

export const tabs = [
  {
    icon: <Info />,
    entity: "detail",
    label: "Detalhes",
    isDetail: true,
  },
  {
    icon: <Info />,
    entity: "eeg_recording",
    label: "EEG Recording",
    isDetail: false,
  },
];
